import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    reply1:
      "On Bluetooth mode, both iOS and Android smartphones are compatible for use in eGeeTouch® Smartlock.",
    reply2:
      "On NFC mode, eGeeTouch® Smartlock is compatible most NFC Android Smartphones running Android 4.4 or above and also leading brand NFC-enabled Sportbands. To date, the eGeeTouch NFC-Smartlock has been tested on Samsung Galaxy Note 2, Samsung Galaxy S3, S6, SONY Xperia Z3, HTC One M7, Fitbit Sportband Charge & Charge-HR etc.",
    reply3:
      "On Android smartphone NFC mode, user needs to locate the sensitive area of smartphone's NFC antenna at the back-side of these Smartphones simply by placing the Smartphone as closely as possible to the receptor area ('Tap Here' mark) of smartlock. Continuous testing on other models of smartphones have been scheduled and shall be updated accordingly in due course.",
    back: "Back",
  },
  ja: {
    reply1:
      "Bluetooth モードでは、iOS および Android スマートフォンの両方が eGeeTouch® スマート ロックでの使用に互換性があります。",
    reply2:
      "NFC モードでは、eGeeTouch® スマート ロックは、Android 4.4 以降を実行するほとんどの NFC Android スマートフォンおよび主要ブランドの NFC 対応スポーツバンドと互換性があります。現在までに、eGeeTouch NFC-スマート ロックは、Samsung Galaxy Note 2、Samsung Galaxy S3、S6、SONY Xperia Z3、HTC One M7、Fitbit Sportband Charge & Charge-HR などでテストされています。",
    reply3:
      "Android スマートフォンの NFC モードでは、ユーザーはスマートフォンをスマートロックの受光領域 (「ここをタップ」マーク) にできるだけ近づけて置くだけで、スマートフォンの背面にあるスマートフォンの NFC アンテナの感知領域を見つける必要があります。スマートフォンの他のモデルでの継続的なテストが予定されており、適宜更新される予定です。",
    back: "戻る",
  },
  es: {
    reply1:
      "En el modo Bluetooth, tanto los teléfonos inteligentes iOS como Android son compatibles para su uso en la candado inteligente eGeeTouch®.",
    reply2:
      "En el modo NFC, el bloqueo inteligente eGeeTouch® es compatible con la mayoría de los teléfonos inteligentes Android con NFC que ejecutan Android 4.4 o superior y también con las pulseras deportivas habilitadas para NFC de marcas líderes. Hasta la fecha, la candado inteligente eGeeTouch NFC se ha probado en Samsung Galaxy Note 2, Samsung Galaxy S3, S6, SONY Xperia Z3, HTC One M7, Fitbit Sportband Charge & Charge-HR, etc.",
    reply3:
      'En el modo NFC de los teléfonos inteligentes Android, el usuario debe ubicar el área sensible de la antena NFC del teléfono inteligente en la parte posterior de estos teléfonos inteligentes simplemente colocando el teléfono inteligente lo más cerca posible del área receptora (marca "Toque aquí") de la candado inteligente. Se han programado pruebas continuas en otros modelos de teléfonos inteligentes y se actualizarán en consecuencia a su debido tiempo.',
    back: "Atrás",
  },
});

class Q10_component extends Component {
  constructor(props) {
    super(props);

    this.state = {
      triggerValue: "0",
      clicked: false,
      language: "en",
    };
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
          this.setState({ language: snapshot.val() });
        });
    }
  }

  handleButtonClick2 = () => {
    if (!this.state.clicked) {
      this.setState({ triggerValue: "cancel", clicked: true }, () => {
        this.props.triggerNextStep({
          value: "cancel",
          trigger: "cancel",
        });
      });
    }
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const buttonStyle = {
      marginTop: "10px",
      width: "215px",
      backgroundColor: "#FFC500",
      color: "black",
      borderRadius: "25px",
      textAlign: "center",
      padding: "10px 10px",
      cursor: "pointer",
      transition: "background-color 0.3s",
      border: "none",
    };

    const buttonHoverStyle = {
      color: "white",
      backgroundColor: "#EF6C00",
    };

    const { triggerValue, clicked } = this.state;

    return (
      <div>
        {localizationStrings.reply1}
        <br />
        <br />
        {localizationStrings.reply2}
        <br />
        <br />
        {localizationStrings.reply3}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            margin: "12px 0",
          }}
        >
          <button
            style={{
              ...buttonStyle,
              ...(triggerValue === "cancel" && buttonHoverStyle),
            }}
            onMouseEnter={() => this.setState({ isButtonHovered: true })}
            onMouseLeave={() => this.setState({ isButtonHovered: false })}
            onClick={this.handleButtonClick2}
            disabled={clicked}
          >
            {localizationStrings.back}
          </button>
        </div>
      </div>
    );
  }
}

export default Q10_component;
